// eslint-disable-next-line import/no-cycle
import { postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		status: null,
		showSbpHelp: false,
	}),
	mutations: {
		setInfoStatus(state, val) {
			state.status = val;
		},
		showSbpHelp(state, val) {
			state.showSbpHelp = val;
		},
	},
	actions: {
		async confirmRejection() {
			const response = await postApi('/k5/v1/loan-app/confirm-rejection');
			return response;
		},
	},
};
